import { defineComponent as _defineComponent } from 'vue'
import { computed, ref, toRefs, useContext, watch } from '@nuxtjs/composition-api';
import type { AsyncComponent, Component, DefineComponent } from 'vue';
import type { MetaUser } from '~/core/models/MetaUser';
import { ACTIONS } from '~/store/affility/user/flows/terms-and-conditions/names';

interface Props {
    visible?: boolean,
    closable?: boolean,
    acceptable?: boolean,
    standalone?: boolean,
    loading?: boolean,
    error?: unknown,
    title: string,
    termsAndConditionsContentProps?: Record<number | string | symbol, unknown>,
    termsAndConditionsComponent?: string | Object | Function | DefineComponent | AsyncComponent | Component;
    user?: MetaUser,
}


export default /*#__PURE__*/_defineComponent({
  __name: 'TermsAndConditions',
  props: {
    visible: { type: Boolean },
    closable: { type: Boolean, default: true },
    acceptable: { type: Boolean, default: true },
    standalone: { type: Boolean, default: false },
    loading: { type: Boolean, default: false },
    error: { default: null },
    title: null,
    termsAndConditionsContentProps: null,
    termsAndConditionsComponent: null,
    user: { default: null }
  },
  emits: ['input'],
  setup(__props: any, { emit: $emit }) {

const props = __props as { visible?: boolean, closable: boolean, acceptable: boolean, standalone: boolean, loading: boolean, error: unknown, title: string, termsAndConditionsContentProps?: Record<number | string | symbol, unknown>, termsAndConditionsComponent?: string | Object | Function | DefineComponent | AsyncComponent | Component, user: MetaUser };

const { store } = useContext();





const {
    visible,
    closable,
    acceptable,
    standalone,
    loading,
    error,
    title,
    termsAndConditionsContentProps,
    termsAndConditionsComponent,
    user,
} = toRefs(props);

const internalVisible = ref(visible.value);

watch(visible, (value) => {
    internalVisible.value = value;
});
watch(internalVisible, (value) => {
    if (value === visible.value) {
        return;
    }
    $emit('input', value);
});

const closeTermsAndConditionsPopup = computed(() => {
    return standalone.value ?
        store.dispatch.bind(null, `affility/user/flows/terms-and-conditions/${ACTIONS.CALL_ACCEPT_ACTION_AND_CLOSE}`):
        store.dispatch.bind(null, `affility/user/flows/terms-and-conditions/${ACTIONS.CLOSE_TERMS_AND_CONDITIONS}`);
})

return { __sfc: true,store, $emit, props, visible, closable, acceptable, standalone, loading, error, title, termsAndConditionsContentProps, termsAndConditionsComponent, user, internalVisible, closeTermsAndConditionsPopup }
}

})